import Button from '@adsk/nirvana-button';
import Flex from '@adsk/nirvana-flex';
import Modal from '@adsk/nirvana-modal';
import { styled, colors } from '@adsk/nirvana-theme';

export const Wrapper = styled(Modal)`
  ${Modal.Body} {
    padding: 0;
    height: 440px;
    position: relative;
    overflow: hidden;
  }
`;

export const BodyWrapper = styled(Flex).attrs({ direction: 'column' })`
  height: 100%;
`;

export const FolderTreeWrapper = styled(Flex).attrs({ flex: '1' })``;

export const Footer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
`;

export const FooterTip = styled.div`
  overflow: hidden;
  flex: auto;
  text-align: left;
  color: ${colors.blue500};
`;

export const FooterAction = styled.div`
  flex: none;
  margin-left: 6px;
`;

export const FooterButton = styled(Button)`
  & + & {
    margin-left: 8px;
  }
`;
